import request from '@/utils/request'

// 사업장 관리 조회
export function getCompManage(params, isNotify) {
  return request({
    url: `/api/getCompManage`,
    method: 'POST',
    data: params,
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json' },
    Notify: { use: isNotify, apitype: 'searched' }
  })
}
// 사업장 관리 저장
export function saveCompManage(params, isNotify) {
  return request({
    url: `/api/saveCompManage`,
    method: 'POST',
    data: params,
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json' },
    Notify: { use: isNotify, apitype: 'saved' }
  })
}
// 사업장 관리 초기데이터 조회
export function getCompManageClientInfo(params, isNotify) {
  return request({
    url: `/api/getCompManageClientInfo`,
    method: 'POST',
    data: params,
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json' },
    Notify: { use: isNotify, apitype: 'searched' }
  })
}
// 사업장 관리 상세페이지 조회
export function getCompManageDetail(params, isNotify) {
  return request({
    url: `/api/getCompManageDetail`,
    method: 'POST',
    data: params,
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json' },
    Notify: { use: isNotify, apitype: 'searched' }
  })
}
// 사업장 관리 상세페이지 공통코드 조회
export function getCompManageDetailCommonCode(isNotify) {
  return request({
    url: `/api/getCompManageDetailCommonCode`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json' },
    Notify: { use: isNotify, apitype: 'searched' }
  })
}
// 사업장 관리 상세페이지 저장
export function saveCompManageDetail(params, isNotify) {
  return request({
    url: `/api/saveCompManageDetail`,
    method: 'POST',
    data: params,
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json' },
    Notify: { use: isNotify, apitype: 'saved' }
  })
}
